import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import ScheduleCategoryContainer from 'common/schedule/ScheduleCategoryContainer';
import FilterGroupContainer from 'common/schedule/FilterGroupContainer';
import { userAuthSelector } from 'common/selectors/authenticationSelectors';
import { fetchSchedule } from 'common/schedule/actions';
import styles from './style';

class SyndicatedScheduleModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            init: true,
            opened: false
        };
        this.fetchAction = fetchSchedule;
        this.onToggleClick = this.onToggleClick.bind(this);
    }

    onToggleClick() {
        const { location: { query } } = this.props;
        const state = { opened: !this.state.opened };
        if (this.state.init) {
            this.props.dispatch(this.fetchAction({ type: 'live', ...query }));
            state.init = false;
        }
        this.setState(state);
    }

    render() {
        const {
            location,
            location: { query: { partner } },
            listings: listingsArg,
            loading,
            userAuth,
            selectedTab,
            isMobile,
            hovered,
            hidden
        } = this.props;
        const { opened } = this.state;
        const tabClassname = classNames('watch-tab', { loading });
        const label = opened ? 'Close' : 'Schedule';
        const containerStyle = opened ? {
            ...styles.container,
            ...styles.opened
        } : styles.container;
        const buttonStyle = !opened && !hovered ? {
            ...styles.toggleButton,
            ...styles.toggleButtonHide,
            ...(hidden ? styles.toggleButtonHidden : {})
        } : styles.toggleButton;

        let listings = listingsArg;

        listings = listings.filter(({ subcategories }) => {
            // Only listings that match the `partner` query param, if provided
            let partnerMatch = false;

            if (partner && subcategories[0]) {
                const league = subcategories[0];
                const partnerRegEx = new RegExp(`${partner}|${partner.replace('-', ' ')}`, 'i');
                const codeMatch = (league.code && league.code.match(partnerRegEx));
                const idMatch = (league.id && league.id.toLowerCase() === partner.toLowerCase());
                const nameMatch = !!(league.name && league.name.match(partnerRegEx));

                partnerMatch = (codeMatch || idMatch || nameMatch);
            }

            return (partnerMatch);
        });

        return (
            <div style={containerStyle}>
                <a style={buttonStyle} onClick={this.onToggleClick}>
                    <span style={styles.toggleButtonLabel}>{label}</span>
                </a>
                <article className="watch-schedule" style={styles.scheduleContainer}>
                    <FilterGroupContainer
                        location={location}
                        showSportOptions={false}
                        showNetworkOptions={false}
                        fetchAction={this.fetchAction}
                    />
                    <div className="content" style={selectedTab !== 'upcoming' ? { paddingTop: 20 } : {}}>
                        <div id="tabLive" className={tabClassname} style={{ display: 'block' }}>
                            <ScheduleCategoryContainer
                                listings={listings}
                                userAuth={userAuth}
                                selectedTab={selectedTab}
                                isMobile={isMobile}
                                startDateValue={location.query.startDate}
                                showSectionCaption={false}
                                watchRegion={location.query.watchRegion}
                            />
                        </div>
                    </div>
                </article>
            </div>
        );
    }
}

SyndicatedScheduleModule.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    listings: PropTypes.array,
    loading: PropTypes.bool,
    selectedTab: PropTypes.oneOf(['live', 'upcoming', 'replay']),
    userAuth: PropTypes.array,
    isMobile: PropTypes.bool,
    hovered: PropTypes.bool,
    hidden: PropTypes.bool
};

const mapStateToProps = (state) => {
    const { app, schedule } = state;
    const userAuth = userAuthSelector(state);
    return {
        userAuth,
        selectedTab: schedule.statusFilterValue,
        listings: schedule.listings || [],
        loading: schedule.loading,
        isMobile: app.isMobile
    };
};

export default connect(mapStateToProps)(SyndicatedScheduleModule);



// WEBPACK FOOTER //
// ./app/webapp/syndicated/SyndicatedScheduleModule/index.js